import { FormattedMessage } from "react-intl";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import { TicketStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { Link } from "@react-navigation/native";
import { RootNavigationParamList } from "navigation/RootNavigation/types";
import { SCREENS } from "navigation/consts";

import * as Styled from "./styles";
import { TicketListItemProps } from "./types";

const TicketListItem: React.FC<TicketListItemProps> = ({
  id: ticketId,
  ticketNumber,
  order,
  status,
  eventOccurrenceId,
}) => (
  <Link<RootNavigationParamList>
    to={{
      screen: SCREENS.TicketDetails,
      params: { eventOccurrenceId, ticketId },
    }}
  >
    <Styled.Wrapper>
      <Styled.Cell>{order?.firstName || "-"}</Styled.Cell>
      <Styled.Cell>{order?.lastName || "-"}</Styled.Cell>
      <Styled.Cell>{ticketNumber || "-"}</Styled.Cell>
      <Styled.Cell>
        <Text fontSize="0.5rem" fontWeight="bold">
          {status === TicketStatus.SCANNED && (
            <FormattedMessage defaultMessage="Checked-In" />
          )}
          {status === TicketStatus.NEW && (
            <FormattedMessage defaultMessage="Pending" />
          )}
        </Text>
      </Styled.Cell>
    </Styled.Wrapper>
  </Link>
);

export default TicketListItem;
